export const AddToShoppinglist = (
  <svg
    width="24"
    height="24"
    viewBox="-2 -2 19 19"
    fill="none"
    stroke="#484848"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12733_79623)">
      <path d="M9 15.5H0.5V0.5H11.5V5" />
      <line x1="7" y1="11.5" x2="16" y2="11.5" />
      <line x1="3" y1="8" x2="9" y2="8" />
      <line x1="3" y1="11.5" x2="5" y2="11.5" />
      <line x1="3" y1="4.5" x2="9" y2="4.5" />
      <line x1="11.5" y1="7" x2="11.5" y2="16" />
    </g>
  </svg>
)
